import { render, staticRenderFns } from "./QuestionHandle.vue?vue&type=template&id=0c52dc51&scoped=true"
import script from "./QuestionHandle.ts?vue&type=script&lang=ts&external"
export * from "./QuestionHandle.ts?vue&type=script&lang=ts&external"
import style0 from "./QuestionHandle.vue?vue&type=style&index=0&id=0c52dc51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c52dc51",
  null
  
)

export default component.exports